import React from 'react';
import { Badge, ListGroup } from 'react-bootstrap';

const ACTION_LABELS = {
    reported: 'Request reported',
    saved: 'Draft saved',
    submitted: 'Submitted for approval',
    approved: 'Approved',
    rejected: 'Rejected',
};

const historyDateFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kuala_Lumpur',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});

function actionLabel(action) {
    if (ACTION_LABELS[action]) return ACTION_LABELS[action];

    const label = String(action || 'Updated')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[-_]/g, ' ');

    return label.charAt(0).toUpperCase() + label.slice(1);
}

export function AssetMaintenanceRequestHistory({ events = [] }) {
    return (
        <section aria-labelledby="request-history-title" className="mt-3 mb-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                <h5 id="request-history-title" className="mb-0">Request history</h5>
                <small className="text-muted">Malaysia time (UTC+8)</small>
            </div>
            {events.length ? (
                <ListGroup as="ol">
                    {events.map((event, index) => {
                        const date = event.at ? new Date(event.at) : null;
                        const validDate = date && Number.isFinite(date.getTime());

                        return (
                            <ListGroup.Item as="li" key={index} className="py-3">
                                <div className="d-flex flex-wrap justify-content-between gap-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="fw-semibold">{actionLabel(event.action)}</span>
                                        {event.cycle != null && (
                                            <Badge bg="light" text="dark">
                                                Approval cycle {event.cycle}
                                            </Badge>
                                        )}
                                    </div>
                                    <time
                                        className="small text-muted"
                                        dateTime={validDate ? date.toISOString() : undefined}
                                    >
                                        {validDate ? historyDateFormat.format(date) : 'Time unavailable'}
                                    </time>
                                </div>
                                {event.reason && <p className="mt-2 mb-0">{event.reason}</p>}
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            ) : (
                <p className="text-muted mb-0">No request history yet.</p>
            )}
        </section>
    );
}
